module.exports = __webpack_public_path__ + "static/media/VeryDangerousThings.6abfdfac.jpg";